module.exports = __webpack_public_path__ + "static/media/edukacyjne-gry-dla-dzieci.ed71199e.png";